import { useMemo } from 'react'
import { useQuery } from '@apollo/client/react'
import { CurrenciesDocument } from '@/graphql/generated/graphql'

/**
 * Catálogo de monedas. Expone:
 * - `currencies`: sólo las activas (para el selector del formulario).
 * - `defaultCurrencyId`: la moneda principal (`isMain`) o la primera activa.
 * - `currencyNameById`: para formatear importes de movimientos por su `currencyId`.
 */
export function useCurrencies() {
  const { data, loading, error } = useQuery(CurrenciesDocument, {
    variables: { take: 200, skip: 0 },
    fetchPolicy: 'cache-first',
  })

  const items = data?.currencies.items

  const currencies = useMemo(() => (items ?? []).filter((c) => c.isActive), [items])

  const defaultCurrencyId = useMemo(() => {
    const main = currencies.find((c) => c.isMain) ?? currencies[0]
    return main?.id ?? null
  }, [currencies])

  const currencyNameById = useMemo(() => {
    const map = new Map<number, string>()
    for (const c of items ?? []) map.set(c.id, c.name)
    return map
  }, [items])

  return { currencies, defaultCurrencyId, currencyNameById, loading, error }
}
